import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

/*
  Slapukų sutikimas v2 (GDPR):
  - localStorage 'cookie_consent_v2' = {"analytics":bool,"marketing":bool,"ts":number}
  - Senas formatas 'cookie_consent'="1" migruojamas kaip pilnas sutikimas.
  - Pasirinkimą vėliau galima atidaryti per window.openCookieSettings()
*/

function readConsent() {
  try {
    const v2 = localStorage.getItem("cookie_consent_v2");
    if (v2) return JSON.parse(v2);
    if (localStorage.getItem("cookie_consent") === "1") {
      return { analytics: true, marketing: true, legacy: true };
    }
  } catch (e) {}
  return null;
}

function applyConsent(analytics, marketing) {
  try {
    localStorage.setItem(
      "cookie_consent_v2",
      JSON.stringify({ analytics, marketing, ts: Date.now() })
    );
    localStorage.removeItem("cookie_consent"); // senas raktas nebereikalingas
  } catch (e) {}
  try {
    window.gtag?.("consent", "update", {
      analytics_storage: analytics ? "granted" : "denied",
      ad_storage: marketing ? "granted" : "denied",
      ad_user_data: marketing ? "granted" : "denied",
      ad_personalization: marketing ? "granted" : "denied",
    });
    if (marketing) window.loadMetaPixel?.();
  } catch (e) {}
}

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const [settings, setSettings] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const c = readConsent();
    if (!c) setShow(true);
    // Galimybė vėliau pakeisti pasirinkimą (pvz. iš footer nuorodos)
    window.openCookieSettings = () => {
      const cur = readConsent();
      setAnalytics(!!cur?.analytics);
      setMarketing(!!cur?.marketing);
      setSettings(true);
      setShow(true);
    };
    return () => { delete window.openCookieSettings; };
  }, []);

  if (!show) return null;

  const acceptAll = () => { applyConsent(true, true); setShow(false); };
  const necessaryOnly = () => { applyConsent(false, false); setShow(false); };
  const saveSelected = () => { applyConsent(analytics, marketing); setShow(false); };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[90] bg-white dark:bg-[#111A28] border-t border-gray-200 dark:border-gray-700 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-6">
          <p className="text-sm text-gray-600 dark:text-gray-300 flex-1">
            Naudojame būtinuosius slapukus, kad svetainė veiktų. Jums sutikus, papildomai naudosime statistikos (Google Analytics) ir rinkodaros (Meta Pixel) slapukus.{" "}
            <Link to="/privatumas" className="text-[#00B5E2] hover:underline">Privatumo politika</Link>
          </p>
          <div className="flex flex-col sm:flex-row gap-2 shrink-0 w-full lg:w-auto">
            <button type="button" onClick={() => setSettings(!settings)} className="btn-secondary text-sm justify-center" data-testid="cookie-settings-btn">
              Nustatymai
            </button>
            <button type="button" onClick={necessaryOnly} className="btn-secondary text-sm justify-center" data-testid="cookie-necessary">
              Tik būtini
            </button>
            <button type="button" onClick={acceptAll} className="btn-primary text-sm justify-center" data-testid="cookie-accept">
              Sutinku su visais
            </button>
          </div>
        </div>

        {settings && (
          <div className="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6" data-testid="cookie-settings-panel">
            <label className="flex items-center gap-2 text-sm text-gray-400 dark:text-gray-500">
              <input type="checkbox" checked disabled className="accent-[#00B5E2]" />
              Būtini <span className="text-[10px] font-mono">(visada įjungti)</span>
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200 cursor-pointer">
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="accent-[#00B5E2]" data-testid="cookie-toggle-analytics" />
              Statistika <span className="text-[10px] font-mono text-gray-400">(Google Analytics)</span>
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200 cursor-pointer">
              <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="accent-[#00B5E2]" data-testid="cookie-toggle-marketing" />
              Rinkodara <span className="text-[10px] font-mono text-gray-400">(Meta Pixel)</span>
            </label>
            <button type="button" onClick={saveSelected} className="btn-primary text-sm justify-center sm:ml-auto" data-testid="cookie-save-selected">
              Patvirtinti pasirinktus
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
